import { css } from "styled-components";

const variables = css`
    :root {
        --primary: #020c1b;
        --secondary: #0a192f;
        --light: #a8b2d1;
        --lightest: #e6f1ff;
        --accent: #64ffda;
        --accent-tint: rgba(100, 255, 218, 0.1);
        --title: #4A4A4A;
        --text: #616161;
        --input-sub: #808080;
        --darkgrey: darkgrey;
        --background: #fff;

        --fz-xxs: 1.2rem;
        --fz-xs: 1.3rem;
        --fz-sm: 1.4rem;
        --fz-md:1.6rem;
        --fz-lg: 1.8rem;
        --fz-xl: 2rem;
        --fz-xxl: 2.2rem;
        --fz-heading: 3.2rem;

        --border-radius: 4px;
        --nav-height: 10rem;
        --nav-scroll-height: 7rem;
    }
`

export default variables;
